<template>
    <div>
        <label :style="'color:' + fieldsColor" :class="{'required': field.required}">
            {{ formatTitle(field.name) }}
            <img v-if="path.icon !== undefined" :src="path.icon" height="20px">
            <help-tooltip :content="field.helpDescription"></help-tooltip>
        </label>
        <v-textarea
          class="textarea mb-5"
          :value="fieldValue"
          @input="updateProviderByField"
          counter
          :maxlength="path.maxlength !== undefined ? path.maxlength : null"
          :hide-details="path.maxlength === undefined"
          :readonly="readOnly"
          :class="{'input-error': submitted && field.required && (fieldValue === null || fieldValue === '')}"
          outlined>
        </v-textarea>

        <content-a-i v-if="aiModule && aiEnabled && !readOnly"
                     :type-word="aiModule.typeWord"
                     :type="aiModule.type">
        </content-a-i>

        <content-deepl-translation
          v-if="path && path.code === 'DESC_LONG_EN' && !readOnly && origin === 'SIT' && deeplTranslatorEnabled"
          :account-id="deeplTranslatorEnabled.configurable_id"
        >
        </content-deepl-translation>
    </div>
</template>

<script>

import { mapGetters, mapMutations, mapState } from "vuex"
import { fieldsMapping } from "../../../../static/webform"
import ContentDeeplTranslation from "./ContentDeeplTranslation.vue"
import ContentAI from "./ContentAI.vue"
import HelpTooltip from "../../../tools/HelpTooltip.vue"

export default {
    name: "FormTextarea",
    props: ["field"],
    components: { ContentAI, HelpTooltip, ContentDeeplTranslation },
    methods: {
        ...mapMutations("web_form", ["updateProviderFieldValue", "setDirtyTabulation"]),
        updateProviderByField(newValue) {
            this.updateProviderFieldValue([this.path, newValue])
            this.setDirtyTabulation(this.field.tabulation.code)
        },
        formatTitle(title) {
            return title.replace(/ *\([^)]*\) */g, "")
        },
    },
    computed: {
        ...mapState("webFormStyle", [
            "fieldsColor",
        ]),
        ...mapState("web_form", [
            "submitted",
            "provider",
            "aiEnabled",
            "readOnly",
            'origin',
            'deeplTranslatorEnabled',
        ]),
        ...mapGetters("web_form", [
            "getCodeFromField",
            "getProviderFieldValue",
        ]),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        path() {
            return fieldsMapping.find(path => path.code === this.fieldCode)
        },
        fieldValue() {
            return this.getProviderFieldValue(this.path)
        },
        aiModule() {
            let hasModule = null

            if (this.path.modules !== undefined) {
                hasModule = this.path.modules.find(_module => _module.name === "AI")
            }

            return hasModule
        },
    },
}
</script>